import { useRef } from 'react';
import AppRoutes from './routes';
import { useAuthStore } from './stores/auth';

/**
 * 根组件。
 *
 * - 启动时从 localStorage 恢复登录态（restore 只执行一次）
 * - 渲染路由表（含 RequireAuth 守卫）
 */
export default function App() {
  const restored = useRef(false);
  if (!restored.current) {
    restored.current = true;
    useAuthStore.getState().restore();
  }

  return <AppRoutes />;
}
